import { createDocument, getAllData } from "apis/customApiHandler";
import Spinner from "components/Spinner";
import { Input, Select } from "styled";
import { Fragment, useCallback, useState } from "react";
import { BiCloudDownload } from "react-icons/bi";
import { useQuery } from "react-query";
import ReactSelect from "react-select";
import { TD, TH } from "styled/table";
import exportExcel from "utils/exportExcel";
import Modal from "components/Modal";
import {Button} from 'styled';
import getFormattedDate from "utils/helpers";
import axios from 'apis/axios'
import toast from 'react-hot-toast';
import * as XLSX from 'xlsx';


// Default date range for scrap analysis (full data - no 6 month limit)
const getDefaultDateFrom = () => getFormattedDate(new Date(2000, 0, 1));

const contractTypeOptions = [
  { value: 'All', label: 'All' },
  { value: 'CPKM', label: 'CPKM' },
  { value: 'NON CPKM', label: 'NON CPKM' }
];


const ScrapAnalysis = () => {
    const [selectedFleets, setSelectedFleets] = useState([]);
    const [selectedHubs, setSelectedHubs] = useState([]);
    const [selectedReasons, setSelectedReasons] = useState([]);
    const [fleetMap, setFleetMap] = useState({});
    const [tyreValidation, setTyreValidation] = useState("");
    const [soldOut, setSoldOutValidation] = useState("");
    const [dateFrom, setDateFrom] = useState(getDefaultDateFrom());
    const [dateTo, setDateTo] = useState(getFormattedDate(new Date()));
    const [data, setData] = useState([]);
    const [contractType, setContractType] = useState(null)
    const [isLoading, setIsLoading] = useState(false);
    const [downloading, setDownloading ] = useState(false);
    const monthMap = ["", "Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"];
    let totalSum = 0;

    


    const getData = async ()=>{
        setIsLoading(true)
        try{
            const dt = await  createDocument("/report/scrapAnalysis", {
                ...(selectedFleets?.includes("all")
                ? {
                    fleets: getFleetOptions().filter(item => item.value!== "all" && item.value!== "clear")
                    .map((item) => item.value)
                        .join(","),
                    }
                : selectedFleets.length && {
                    fleets: selectedFleets.map((fleet) => fleet).join(","),
                    }),
                ...(selectedHubs?.includes("all")
                ? {
                    hubs: getHubOptions().filter(item => item.value!== "all" && item.value!== "clear")
                        .map((item) => item.value)
                        .join(","),
                    }
                : selectedHubs.length && {
                    hubs: selectedHubs.map((hub) => hub).join(","),
                    }),
                ...(selectedReasons?.includes("all")
                ? {
                    scrapReasons: null
                    }
                : selectedReasons.length && {
                    scrapReasons: selectedReasons.map((reason) => reason).join(","),
                    }),
                ...(dateFrom && {
                    dateFrom,
                }),
                ...(dateTo && {
                    dateTo,
                }),
                ...tyreValidation && { tyreValidation },
                ...soldOut && { soldOut },
                ...contractType && {contractType}
            })
            setData(dt);
            // console.log('dt',dt)
        }catch(err){
        }finally{
            setIsLoading(false)
        }
    }

    const getDownloadData = async ()=>{
    setDownloading(true)
    try{
        const dt = await createDocument("/report/scrapAnalysis", {
        ...(selectedFleets?.includes("all")
            ? {
            fleets: getFleetOptions().filter(item => item.value!== "all" && item.value!== "clear")
            .map((item) => item.value)
                .join(","),
            }
            : selectedFleets.length && {
                fleets: selectedFleets.map((fleet) => fleet).join(","),
            }),
        ...(selectedHubs?.includes("all")
            ? {
            hubs: getHubOptions().filter(item => item.value!== "all" && item.value!== "clear")
            .map((item) => item.value)
                .join(","),
            }
            : selectedHubs.length && {
                hubs: selectedHubs.map((hub) => hub).join(","),
            }),
        ...(selectedReasons?.includes("all")
            ? {
                scrapReasons: null
                }
            : selectedReasons.length && {
                scrapReasons: selectedReasons.map((reason) => reason).join(","),
            }),
        ...(dateFrom && {
            dateFrom,
        }),
        ...(dateTo && {
            dateTo,
        }),
        ...tyreValidation && { tyreValidation },
        ...soldOut && { soldOut },
        ...contractType && {contractType}
        });

        if(dt.data){
            //console.log('dt.data',dt.data)

            const monthNames = dt.months?.map(month => {
                const [year, monthNum] = month.split("-");
                return `${monthMap[parseInt(monthNum)]} ${year}`;
            });

            const exportData = dt.data?.map((entry, idx) => {
                let monthWise = {};
                dt.months.forEach((month, monthIdx) => {
                    const monthKey = monthNames[monthIdx];
                    const tyres = entry.data.find(item => item.month === month)?.tyres ?? 0;
                    monthWise[monthKey] = typeof tyres === "number" ? tyres : (tyres?.length ?? 0);
                });
                const totalCount = typeof entry.total === "number" ? entry.total : (entry.total?.length ?? 0);
                const result = {
                    "S.N": idx + 1,
                    "Fleet Name": `${entry._id.fleet} (${entry.fleetCity})`,
                    ...monthWise,
                    "Total": totalCount
                };
                return result;
            });

            let totalRow = { "S.N": "TOTAL", "Fleet Name": "" };
            let overallTotal = 0;

            dt.months.forEach((month, monthIdx) => { 
                const monthKey = monthNames[monthIdx];
                const totalEntry = dt.total.find(total => total._id.monthYear === month);
                const monthTotal = totalEntry ? totalEntry.tyres : 0;
                totalRow[monthKey] = monthTotal;
                overallTotal += monthTotal;
            });

            totalRow["Total"] = overallTotal;

            exportData.push(totalRow);

            const ws = XLSX.utils.json_to_sheet(exportData);

            const merge = [{ s: { r: exportData.length, c: 0 }, e: { r: exportData.length, c: 1 } }];
            if (!ws['!merges']) ws['!merges'] = [];
            ws['!merges'] = ws['!merges'].concat(merge);
            ws['A' + (exportData.length + 1)] = { t: 's', v: 'TOTAL' };

            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Scrap Analysis");

            XLSX.writeFile(wb, "scrap-analysis.xlsx");
        }
    }catch(err){   
        //console.log("error",err)
    }
    finally{ setDownloading(false) }  
    }
    
    const { data: allFleets } = useQuery([`/customer-fleet`], () =>
        getAllData("/customer-fleet", {
            limit: 3000,
        })
    );
    
    const { data: allHubs } = useQuery([`/customer-hub`], () =>
        getAllData("/customer-hub", {
            limit: 3000,
        })
    );
    
    const { data: allReasons } = useQuery([`/scrap-reason`], () =>
        getAllData("/scrap-reason", {
            limit: 3000,
            page: 1
        })
    );
    
    const getFleetOptions = useCallback(() => {
    if (allFleets && allFleets.data && allFleets.data.length) {
        return [
            {
                label: "All",
                value: "all",
            },
            {
                label: "Clear",
                value: "clear",
            },
            ...allFleets?.data?.map((fleet) => {
                return {
                    value: fleet._id,
                    label: fleet.fleetName,
                };
            }),
        ];
    }
    }, [allFleets]);

    const getHubOptions = useCallback(() => {
    if (allHubs && allHubs.data && allHubs.data.length) {
        return [
          ...selectedFleets?.length ? [{
            label: "All",
            value: "all",
          }]: [],
          ...selectedFleets?.length ? [{
            label: "Clear",
            value: "clear",
          }]: [],
            ...(selectedFleets?.includes("all") ? 
            allHubs?.data?.length &&
                allHubs?.data
                ?.map((hub) => {
                    return {
                    value: hub._id,
                    label: hub.hubName,
                    };
                }) : 
            allHubs?.data?.length &&
                allHubs?.data
                ?.filter((hub) => {
                    const selectedFleetsVal = allFleets?.data?.filter((fleet) =>
                    selectedFleets?.includes(fleet._id)
                    );

                    return selectedFleetsVal?.some(
                    (fleet) => fleet.fleetCode === hub.fleetCode
                    );
                })
                ?.map((hub) => {
                    return {
                    value: hub._id,
                    label: hub.hubName,
                    };
                })),
            ];
        }
    }, [allFleets, allHubs, selectedFleets]);

    const getScrapOptions = useCallback(() => {
        if (allReasons && allReasons.data && allReasons.data.length) {
            return [
                {
                    label: "All",
                    value: "all",
                },
                {
                    label: "Clear",
                    value: "clear",
                },
                ...allReasons?.data?.map((reason) => {
                    return {
                        value: reason.reason,
                        label: reason.reason,
                    };
                }),
            ];
        }
    }, [allReasons]);


    const setFleetMapData = useCallback(() => {
        let selectedFleetCodes = allFleets?.data?.map((fleet) => fleet.fleetCode);
        let selectedHubsData = [];
        if (selectedHubs?.includes("all"))
          selectedHubsData = allHubs?.data?.filter((hub) =>
            selectedFleetCodes?.includes(hub.fleetCode)
          );
        else
          selectedHubsData = allHubs?.data?.filter((hub) =>
            selectedHubs?.includes(hub._id)
          );
        const mp = {};
        selectedHubsData.map((hub) => {
          if (selectedFleetCodes?.includes(hub.fleetCode)) {
            if (mp[hub.fleetCode] === undefined) mp[hub.fleetCode] = [];
            mp[hub.fleetCode] = [...mp[hub.fleetCode], hub._id];
          }
        });
    
        setFleetMap({...mp});
    }, [allFleets?.data, allHubs?.data, selectedHubs]);

    const getModalFilters = useCallback(() => ({
        ...(selectedFleets?.includes("all")
            ? {
                fleets: getFleetOptions()?.filter(item => item.value !== "all" && item.value !== "clear")?.map((item) => item.value)?.join(","),
            }
            : selectedFleets?.length && { fleets: selectedFleets.join(",") }),
        ...(selectedHubs?.includes("all")
            ? {
                hubs: getHubOptions()?.filter(item => item.value !== "all" && item.value !== "clear")?.map((item) => item.value)?.join(","),
            }
            : selectedHubs?.length && { hubs: selectedHubs.join(",") }),
        ...(selectedReasons?.includes("all") ? { scrapReasons: null } : selectedReasons?.length && { scrapReasons: selectedReasons.join(",") }),
        ...(dateFrom && { dateFrom }),
        ...(dateTo && { dateTo }),
        ...(tyreValidation && { tyreValidation }),
        ...(soldOut && { soldOut }),
        ...(contractType && { contractType }),
    }), [selectedFleets, selectedHubs, selectedReasons, dateFrom, dateTo, tyreValidation, soldOut, contractType, getFleetOptions, getHubOptions]);

    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        setDateFrom(selectedDate);
        
        const sixMonthsAheadDate = new Date(selectedDate);
        const fromDate = sixMonthsAheadDate.getDate();
        sixMonthsAheadDate.setMonth(sixMonthsAheadDate.getMonth() + 6);
    
        if (fromDate > sixMonthsAheadDate.getDate() || fromDate === 1) {
          sixMonthsAheadDate.setDate(0);
        }
    
        const currentDate = new Date();
        const finalDate = sixMonthsAheadDate > currentDate ? currentDate : sixMonthsAheadDate;
    
        setDateTo(getFormattedDate(finalDate));
    };    

    return (
      <>
        <div>
          <div className="w-full px-8 flex justify-center items-center gap-4">
            <label className="w-full py-3">
              Select Fleets
              <ReactSelect
                styles={{
                  control: (base, state) => ({
                    ...base,
                    borderColor: "transparent",
                    minWidth: "100%",
                    "&:hover": {
                      borderColor: "rgb(34 197 94)",
                    },
                  }),
                }}
                className="shadow-md rounded-md py-1 mb-2"
                options={getFleetOptions()}
                value={
                  selectedFleets &&
                  selectedFleets?.map((fleet) => {
                    return {
                      value: fleet,
                      label: getFleetOptions()?.find(
                        (item) => item?.value === fleet
                      )?.label,
                    };
                  })
                }
                onChange={(value) => {
                  let allValues = value?.map((item) => item.value);
                  if (allValues?.includes("clear")) {
                    // console.log(allValues)
                    setSelectedFleets([]);
                    setSelectedHubs([]);
                    return;
                  }
                  if (
                    !selectedFleets?.includes("all") &&
                    allValues.includes("all")
                  ) {
                    setSelectedFleets(["all"]);
                    return;
                  }

                  if (selectedFleets.includes("all")) {
                    // console.log("first");
                    // console.log(getFleetOptions())
                    value = value.filter((item) => item.value !== "all");
                  }

                  let selectedFleetsVal = allFleets?.data?.filter((fleet) =>
                    value?.map((item) => item.value)?.includes(fleet._id)
                  );

                  let selectedHubsVal = allHubs?.data?.filter((hub) =>
                    selectedHubs?.map((item) => item)?.includes(hub._id)
                  );

                  setSelectedHubs(
                    selectedHubsVal
                      ?.filter((hub) =>
                        selectedFleetsVal?.find(
                          (fleet) => fleet.fleetCode === hub.fleetCode
                        )
                      )
                      .map((hub) => hub._id)
                  );

                  // console.log({allHubs, selectedHubs})

                  setSelectedFleets(value.map((fleet) => fleet.value));
                }}
                name="fleets"
                isMulti={true}
              />
            </label>
            <label className="w-full py-3">
              Select Hubs
              <ReactSelect
                styles={{
                  control: (base, state) => ({
                    ...base,
                    borderColor: "transparent",
                    minWidth: "100%",
                    "&:hover": {
                      borderColor: "rgb(34 197 94)",
                    },
                  }),
                }}
                className="shadow-md rounded-md py-1 mb-2"
                options={getHubOptions()}
                value={
                  selectedHubs &&
                  selectedHubs?.map((hub) => {
                    // console.log({hub})
                    return {
                      value: hub,
                      label: getHubOptions()?.find((item) => item.value === hub)
                        ?.label,
                    };
                  })
                }
                onChange={(value) => {
                  const allValues = value?.map((item) => item.value);
                  // console.log({allValues})
                  if (allValues.includes("clear")) {
                    setSelectedHubs([]);
                    return;
                  }
                  if (
                    !selectedHubs?.includes("all") &&
                    allValues.includes("all")
                  ) {
                    setSelectedHubs(["all"]);
                  } else {
                    // console.log({value})
                    value = value.filter((value) => value.value !== "all");
                    // console.log({value})
                    let selectedFleetCodes = allFleets?.data
                      ?.filter((fleet) => selectedFleets?.includes(fleet._id))
                      ?.map((fleet) => fleet.fleetCode);
                    // console.log({allValues})

                    const selectedHubsData = allHubs?.data?.filter((hub) =>
                      allValues?.includes(hub._id)
                    );
                    setSelectedHubs(value.map((hub) => hub.value));
                  }
                }}
                name="hubs"
                isMulti={true}
              />
            </label>
            <label className="w-full py-3">
              Scrap Reason
              <ReactSelect
                styles={{
                  control: (base, state) => ({
                    ...base,
                    borderColor: "transparent",
                    minWidth: "100%",
                    "&:hover": {
                      borderColor: "rgb(34 197 94)",
                    },
                  }),
                }}
                className="shadow-md rounded-md py-1 mb-2"
                options={getScrapOptions()}
                value={
                  selectedReasons &&
                  selectedReasons?.map((reason) => {
                    return {
                      value: reason,
                      label: getScrapOptions()?.find(
                        (item) => item?.value === reason
                      )?.label,
                    };
                  })
                }
                onChange={(value) => {
                  let allValues = value?.map((item) => item.value);
                  if (allValues?.includes("clear")) {
                    setSelectedReasons([]);
                    return;
                  }
                  if (
                    !selectedReasons.includes("all") &&
                    allValues.includes("all")
                  ) {
                    setSelectedReasons(["all"]);
                    return;
                  }
                  if (selectedReasons.includes("all")) {
                    value = value.filter((item) => item.value !== "all");
                  }
                  setSelectedReasons(value.map((reasons) => reasons.value));
                }}
                name="reasons"
                isMulti={true}
              />
            </label>
            <label className="w-full py-3">
            Contract Type
            <ReactSelect
           styles={{
            control: (base, state) => ({
              ...base,
              borderColor: 'transparent',
              minWidth: '100%',
              '&:hover': {
                borderColor: 'rgb(34 197 94)',
              },
            }),
          }}
            name="contractType"
            className="shadow-md rounded-md py-1 mb-2"
            value={contractTypeOptions.find(option => option.value === contractType)} // Find the option object based on the value
            onChange={(option) => {
              setContractType(option.value); // Store only the value
            }}
            options={contractTypeOptions}
          />
          </label>
          </div>
          <div className="w-full px-8 flex justify-start items-center gap-4">
            <label className="w-full py-3">
              Tyre Validation
              <Select
                name="tyreValidation"
                value={tyreValidation}
                onChange={(e) => setTyreValidation(e.target.value)}
              >
                <option value={""}>All</option>
                <option value={"Yes"}>Yes</option>
                <option value={"No"}>No</option>
              </Select>
            </label>
            <label className="w-full py-3">
              Sold Out
              <Select
                name="soldOut"
                value={soldOut}
                onChange={(e) => setSoldOutValidation(e.target.value)}
              >
                <option value={""}>All</option>
                <option value={"Yes"}>Yes</option>
                <option value={"No"}>No</option>
              </Select>
            </label>
            <label className="w-full py-3">
              Start Date{" "}
              <Input
                type="date"
                max={getFormattedDate()}
                name="dateFrom"
                value={dateFrom}
                onChange={handleFromDateChange}
              />
            </label>
            <label className="w-full py-3">
              End Date{" "}
              <Input
                type="date"
                min={dateFrom}
                max={getFormattedDate(new Date())}
                name="dateTo"
                value={dateTo}
                onChange={(e) => setDateTo(e.target.value)}
              />
            </label>
            <Button
              type="button"
              className='mt-5'
              bgPrimary
              onClick={() => {
                setFleetMapData();
                getData()
            }}
              disabled={!selectedHubs.length}
            >
              Search
            </Button>
            {downloading
              ? "Downloading..."
              : selectedHubs.length > 0 && (
                  <BiCloudDownload
                    className="w-44 mt-5 h-44 text-green-500 hover:scale-105 cursor-pointer text-center"
                    onClick={() => {
                      getDownloadData();
                    }}
                  />
                )}
          </div>

        </div>
        {isLoading ? (
          <Spinner />
        ) : (
          <div className="flex flex-col m-2 lg:m-10">
            <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                      <tr>
                        <TH scope="col">S.N.</TH>
                        <TH scope="col">Fleet Name</TH>
                        {data && data?.months?.map((month) => (
                          <TH scope="col">
                            {monthMap[parseInt(month?.split("-")[1])]}{" "}
                            {month?.split("-")[0]}
                          </TH>
                        ))}
                        <TH scope="col">Total</TH>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {data &&
                        data.data &&
                        data.data?.map((item, idx) => {
                          return (
                            <ViewList
                              idx={idx}
                              data={item}
                              key={item._id?.fleet ?? idx}
                              months={data.months}
                              fleetMap={fleetMap}
                              fleetId={
                                allFleets?.data?.find(
                                  (fleet) =>
                                    fleet.fleetCode === item._id.fleetCode
                                )?._id
                              }
                              modalFilters={getModalFilters()}
                              selectedReasons={selectedReasons}
                              dateFrom={dateFrom}
                              dateTo={dateTo}
                              tyreValidation={tyreValidation}
                              soldOut={soldOut}
                              contractType={contractType}
                            />
                          );
                        })}
                    </tbody>
                    <tfoot>
                      <tr className="text-gray-600 font-semibold bg-green-100">
                        <TD></TD>
                        <TD scope = "col" >
                          TOTAL
                        </TD>
                        {data && data?.months?.map((month) => {
                          const totalEntry = data.total.find(
                            (total) => total._id.monthYear === month
                          );
                          if (totalEntry) {
                            totalSum += totalEntry.tyres;
                          }
                          return (
                            <TD className="text-center">
                              {totalEntry ? totalEntry.tyres : 0}
                            </TD>
                          );
                        })}
                        <TD className="text-center">{totalSum}</TD>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    );
}

export default ScrapAnalysis;

const ViewList = ({ idx, data, months, fleetMap, fleetId, modalFilters = {}, selectedReasons, dateFrom, dateTo, tyreValidation, soldOut, contractType }) => {
    const [showModal, setShowModal] = useState(false);
    const [modalData, setModalData] = useState({ title: "", data: [], fleetCode: "", month: "" });
    const [modalLoading, setModalLoading] = useState(false);

    const modalHandler = useCallback(
      async (fleetName, month, fleetCode, fleetCity, _count) => {
        if (!fleetId || _count === 0) {
          setShowModal(false);
          setModalData({ title: "", data: [], fleetCode: "", month: "" });
          return;
        }
        setModalLoading(true);
        setShowModal(true);
        setModalData({
          title: `Scrap Details ${fleetName} (${fleetCity || "N/A"}) ${month}`,
          data: [],
          fleetCode,
          month,
        });
        try {
          const res = await createDocument("/report/scrapAnalysis/modalInfo", {
            fleetId,
            month: month === "Total" ? undefined : month,
            ...modalFilters,
          });
          setModalData((prev) => ({ ...prev, data: res?.data ?? [] }));
        } catch {
          setModalData((prev) => ({ ...prev, data: [] }));
        } finally {
          setModalLoading(false);
        }
      },
      [fleetId, modalFilters]
    );

    const closeModal = useCallback(() => {
      setShowModal(false);
      setModalData({ title: "", data: [], fleetCode: "", month: "" });
    }, []);

    const count = (val) => (typeof val === "number" ? val : (val?.length ?? 0));

    const downloadDiv = (fleetName, month, tyresOrCount, fleetCode, fleetCity) => {
        const c = count(tyresOrCount);
        return c > 0 ? (
          <div className="flex gap-2 items-center justify-center">
            <span
              className="hover:text-green-500 cursor-pointer"
              onClick={() => modalHandler(fleetName, month, fleetCode, fleetCity, c)}
            >
              {c}
            </span>
          </div>
        ) : (
          <div className="flex gap-2 items-center justify-center">
            <span>0</span>
          </div>
        );
    }
    return (
        <Fragment>
            {showModal && (
                <Modal
                  handleClick={closeModal}
                  title={modalData.title}
                  className="max-w-2xl"
                >
                  <h1 className="w-full flex justify-end text-end px-2 my-1">
                    <Button
                      onClick={() => {
                        const myPromise = axios({
                          method: "post",
                          data: {
                            ...(fleetMap[modalData?.fleetCode]?.length && {
                              hubs: fleetMap[modalData?.fleetCode].map((hub) => hub).join(","),
                            }),
                            ...(fleetId && { fleets: fleetId.toString() }),
                            ...(selectedReasons?.includes("all")
                              ? { scrapReasons: null }
                              : selectedReasons?.length && {
                                  scrapReasons: selectedReasons.map((r) => r).join(","),
                                }),
                            ...(tyreValidation && tyreValidation !== "All" && { tyreValidation }),
                            ...(soldOut && soldOut !== "All" && { soldOut }),
                            ...(dateFrom && { dateFrom }),
                            ...(dateTo && { dateTo }),
                            contractType,
                            month: modalData?.month,
                            reportName: "Scrap Analysis Report",
                          },
                          url: "report/fleetStockDetails/download/scrap",
                        });
                        toast.promise(myPromise, {
                          loading: "Request Initiated, Please Hold on",
                          success: (dt) => dt.data?.message,
                          error: (err) =>
                            err?.response?.data?.error ||
                            err?.response?.data?.message ||
                            err?.message ||
                            "Something went wrong",
                        }, { success: { duration: 3000, icon: "📩" } });
                      }}
                      className=" text-blue-500 hover:scale-105 cursor-pointer text-right"
                      disabled={!modalData?.data?.length}
                    >
                      Download
                    </Button>
                  </h1>
                  {modalLoading ? (
                    <div className="py-8 flex justify-center">
                      <Spinner />
                    </div>
                  ) : (
                    <table className="min-w-full divide-y divide-gray-200">
                      <thead className="bg-gray-50">
                        <tr>
                          <TH scope="col">S.N.</TH>
                          <TH scope="col">Remove Date</TH>
                          <TH scope="col">Remove By</TH>
                          <TH scope="col">Vehicle Registration Number</TH>
                          <TH scope="col">Tyre Position</TH>
                          <TH scope="col">Removed Stencil Number</TH>
                          <TH scope="col">Scrap Reason</TH>
                          <TH scope="col">Average NSD</TH>
                          <TH scope="col">Run KM</TH>
                          <TH scope="col">Tyre Validated By</TH>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {(modalData?.data || []).map((scrap, index) => (
                          <tr key={scrap.stencilNo ?? index}>
                            <TD>{index + 1}</TD>
                            <TD>{scrap.removedDate}</TD>
                            <TD>{scrap.removedBy}</TD>
                            <TD>{scrap.registrationNumber}</TD>
                            <TD>{scrap.position}</TD>
                            <TD>{scrap.stencilNo}</TD>
                            <TD>{scrap.scrapReason}</TD>
                            <TD>{parseFloat(Number(scrap.removedNSD ?? 0))?.toFixed(2)}</TD>
                            <TD>{scrap.totalKillometerTravelled}</TD>
                            <TD>{scrap.validatedBy}</TD>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </Modal>
            )}
            <tr className={`${idx % 2 !== 0 && "bg-gray-100"}`}>
                <TD>{idx + 1}</TD>
                <TD>{`${data._id.fleet} (${data.fleetCity || "N/A"})`}</TD>
                {months.map((month) => (
                  <TD key={month}>
                    {downloadDiv(
                      data._id.fleet,
                      month,
                      data.data.find((item) => item.month === month)?.tyres,
                      data._id.fleetCode,
                      data.fleetCity
                    )}
                  </TD>
                ))}
                <TD className="text-center">
                  {downloadDiv(data._id.fleet, "Total", data.total, data._id.fleetCode, data.fleetCity)}
                </TD>
            </tr>
        </Fragment>
    );
}